import { render } from "./connection_bill.vue?vue&type=template&id=3516b1bd&scoped=true"
import script from "./connection_bill.vue?vue&type=script&lang=js"
export * from "./connection_bill.vue?vue&type=script&lang=js"

import "./connection_bill.vue?vue&type=style&index=0&id=3516b1bd&lang=scss&scoped=true"
import "./connection_bill.vue?vue&type=style&index=1&id=3516b1bd&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3516b1bd"]])

export default __exports__